import { html, render } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'
import { RaygunElement } from '@src/js/common/rg-element.js'

@customElement('rg-map-marker')
export class RgMapMarker extends RaygunElement {

  @property({ type: String })
  lat = ''

  @property({ type: String })
  lng = ''

  @property({ type: String })
  title = ''

  @property({ type: Boolean })
  selected = false

  @property({ type: String })
  icon = ''

  @property({ type: String, attribute: 'icon-active' })
  iconActive = ''

  @state({ type: Object })
  lastParent = null

  notifyChange() {
    if (this.lastParent) {
      this.lastParent.dispatchEvent(new CustomEvent('marker-register', {
        detail: { marker: this }
      }))
    }
  }

  connectedCallback() {
    this.lastParent = this.closest('rg-map')
    this.notifyChange()
    super.connectedCallback()
  }

  disconnectedCallback() {
    this.notifyChange()
    this.lastParent = null
    super.disconnectedCallback()
  }

  render() {
    return html``;
  }
}
